// 3rd party
import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DateAdapter } from '@angular/material';

// models
import { ContactCustomer } from 'app/shared/models/contact-customer.model';

// services
import { AuthService } from 'app/shared/services/auth/auth.service';
import { AuthGuardLogin } from './shared/services/auth/auth.guard';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html'
})
export class AppComponent implements OnInit {

  currentContact: ContactCustomer;
  lang: string = 'pt';
  showApp: boolean = false;

  constructor(
    private authService: AuthService,
    private authGuardLogin: AuthGuardLogin,
    private translate: TranslateService,
    public dateAdapter: DateAdapter<Date>
  ) {
    translate.addLangs(['en', 'pt']);
    translate.setDefaultLang('pt');

    this.refreshSystemLanguage();
  }

  ngOnInit() {
    this.authService.currentContact.subscribe(cc => this.currentContact = cc);
    this.authService.showApp.subscribe(show => this.showApp = show);
    if (!this.currentContact && this.showApp === false) {
      this.authGuardLogin.currentContact.subscribe(cc => this.currentContact = cc);
      this.authGuardLogin.showApp.subscribe(show => this.showApp = show);
    }

    if (!this.showApp) {
      this.authService.checkAccess();
    }
  }

  refreshSystemLanguage() {
    this.lang = this.currentContact && this.currentContact.PreferedLanguage ? this.currentContact.PreferedLanguage : (localStorage.getItem('preferedLang') ? localStorage.getItem('preferedLang') : this.translate.getBrowserLang());
    this.translate.use(this.lang.match(/en|pt/) ? this.lang : 'pt');
    this.dateAdapter.setLocale(this.lang.match(/en|pt/) ? this.lang : 'pt');
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts